<template>
    <div>
        <h4>Node Chapter 3</h4>
        <p>テスト用、、、。</p>
    </div>
</template>

<script>
    export default{
        name: 'NodeChapter3',
    }
</script>